import { render, staticRenderFns } from "./appLanding.vue?vue&type=template&id=9482cbde&scoped=true&"
import script from "./appLanding.vue?vue&type=script&lang=js&"
export * from "./appLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9482cbde",
  null
  
)

export default component.exports